import React from 'react';
import { ReactComponent as NotFoundIcon } from 'assets/NotFound.svg';
import { Stack, Typography, Button } from '@mui/material';
import { paths } from 'routes';
import { Link as RouterLink } from 'react-router-dom';

export const NotFound = ({ title = '', caption = '', wrapperSx = {}, showLogout = false }) => {
  return (
    <Stack gap={1} width={1} alignItems="center" border={0} sx={wrapperSx}>
      <NotFoundIcon />
      <Typography variant="h5" fontWeight={700} textAlign="center">
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        {caption}
      </Typography>
      {showLogout && (
        <RouterLink
          to={paths.logout}
        >
          <Button
            size="medium"
            variant="contained"
            sx={{
              backgroundColor: "primary.main",
              '&:hover': {
                backgroundColor: "primary.main",
              },
              // width: 99,
              height: 34,
              fontSize: "0.875rem",
              fontWeight: "500",
              color: "#fff",
              lineHeight: 1.75,
            }}
          >
            Click here to Logout
          </Button>
        </RouterLink>
      )}
    </Stack>
  );
};
